import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Region } from "../models/region.interface";
import { ApiService } from "./api.service";

@Injectable({
  providedIn: "root",
})
export class RegionService {
  constructor(private apiService: ApiService) {}

  getRegions(): Observable<Region[]> {
    return this.apiService.get("/gandadmin/regions");
  }
}
